import { render, staticRenderFns } from "./CanvasImage.vue?vue&type=template&id=0009a95f&scoped=true&"
import script from "./CanvasImage.vue?vue&type=script&lang=js&"
export * from "./CanvasImage.vue?vue&type=script&lang=js&"
import style0 from "./CanvasImage.vue?vue&type=style&index=0&id=0009a95f&lang=scss&scoped=true&"
import style1 from "./CanvasImage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0009a95f",
  null
  
)

export default component.exports